module.exports = __webpack_public_path__ + "static/media/the-red-yeti.ddec6174.svg";